'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

exports['default'] = formlyWarn;

// @ngInject
function formlyWarn(formlyConfig, formlyErrorAndWarningsUrlPrefix, $log) {
  return function warn() {
    if (!formlyConfig.disableWarnings) {
      var args = Array.prototype.slice.call(arguments);
      var warnInfoSlug = args.shift();
      args.unshift('Formly Warning:');
      args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
      $log.warn.apply($log, _toConsumableArray(args));
    }
  };
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./services/formlyWarn.js
 **/